import React from 'react';
import { Redirect } from 'react-router-dom';

// Pages
import LoginPage from 'pages/root/LoginPage';
import PropTypes from 'prop-types';

import { usePermissions, useUser } from 'hooks';
import { sessionToken } from 'utils';

function InstitutionGuard(props) {
  const { children } = props;

  // Custom hooks
  const { isAuthenticated } = useUser();
  const { permissions } = usePermissions();

  // Constants
  const { isInstitution, isStaff } = permissions;
  const { token } = sessionToken();

  if (!isAuthenticated && !token) return <LoginPage />;

  if (!isStaff && !isInstitution) return <Redirect to="/not-authorized" />;

  return children;
}

InstitutionGuard.propTypes = {
  children: PropTypes.any,
};

export default InstitutionGuard;
